import { render, staticRenderFns } from "./VirtualMuseumSection.vue?vue&type=template&id=3761b68f&scoped=true"
import script from "./VirtualMuseumSection.vue?vue&type=script&lang=js"
export * from "./VirtualMuseumSection.vue?vue&type=script&lang=js"
import style0 from "./VirtualMuseumSection.vue?vue&type=style&index=0&id=3761b68f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3761b68f",
  null
  
)

export default component.exports